import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        auditFileUpload: builder.query<AuditFileUploadResponse, AuditFileUploadRequest>({
            query: (request: AuditFileUploadRequest) => ({
                url: "auditEvent",
                body: request,
                method: "POST",
            }),
        }),
        getAuditRecords: builder.query<AuditRecordsResponse, AuditRecordsRequest>({
            query: (request: AuditRecordsRequest) => ({
                url: "getEventAuditRecord",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useLazyAuditFileUploadQuery, useLazyGetAuditRecordsQuery } = extendedApi;

export interface AuditFileUploadRequest {
    useCase: "FILE_UPLOAD" | string;
    businessUseCase: "SMART" | string;
    auditDetails: {
        uploadedBy: string;
        role?: string;
        fileName: string;
        fileSizeInMB: number;
        fileType: string;
        uploadTimeStamp: string;
        uploadSource: string;
        s3Key: string;
    };
}

export interface AuditFileUploadResponse {
    status: string;
    content: {
        eventId: string;
        itemTimeStamp: string;
    };
}

export interface AuditRecordsRequest {
    eventUseCase: "FILE_UPLOAD" | string;
    businessUseCase: "SMART" | string;
    exclusiveStartKey: any;
}

export interface AuditRecordsResponse {
    auditItemsResponse: {
        totalItemsInResponse: number;
        auditItemsList: Array<AuditItem>;
    };
    exclusiveStartKeyForNextCall: any | null;
}

export type AuditItem = {
    itemHashKey: string;
    itemPrefixID: string;
    contentMap: ContentMap;
    creationTimeStamp: string;
    eventId: string;
    eventUseCase: string;
    itemID: string;
    itemPrefix: string;
    itemType: string;
    useCase: string;
};

export type ContentMap = {
    fileName: string;
    fileSizeInMB: string;
    fileType: string;
    s3Key: string;
    status: string;
    uploadedBy: string;
    uploadSource: string;
    uploadTimeStamp: string;
};
